/* unplugin-vue-components disabled */import { render } from "./Home.vue?vue&type=template&id=3dd2e005&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=3dd2e005&scoped=true&lang=scss"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd2e005"],['__file',"src/views/home/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dd2e005"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dd2e005', __exports__)) {
    console.log('reload')
    api.reload('3dd2e005', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=3dd2e005&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('3dd2e005', render)
  })

}


export default __exports__